// ─── FILTRO DE MENÚ ───────────────────────────────────────────
// Filtra las .product-card por categoría usando delegación de
// eventos sobre el contenedor de tabs (.menu-tabs). Las tarjetas
// que aparecen hacen un fade-in (si no se pidió menos movimiento).
(() => {
  "use strict";

  const tabsContainer = document.querySelector(".menu-tabs");
  if (!tabsContainer) return;

  const tabs = document.querySelectorAll(".tab");
  const cards = document.querySelectorAll(".product-card");
  const animate = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  tabsContainer.addEventListener("click", (event) => {
    const button = event.target.closest(".tab");
    if (!button) return;

    const category = button.dataset.filter;

    tabs.forEach((tab) => {
      const isActive = tab === button;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-pressed", String(isActive));
    });

    cards.forEach((card) => {
      // "todos" = todas; "destacados" = solo las marcadas como favoritas
      // (pestaña de sistema, sin categoría propia); el resto, por categoría.
      let show;
      if (category === "todos") {
        show = true;
      } else if (category === "destacados") {
        show = card.dataset.fav === "1";
      } else {
        show = card.dataset.cat === category;
      }
      card.hidden = !show;

      if (show && animate) {
        card.classList.remove("is-entering");
        void card.offsetWidth; // fuerza reflow para reiniciar la animación
        card.classList.add("is-entering");
      }
    });
  });
})();
